// extracted by mini-css-extract-plugin
export var buttonGroupArea = "index-module--button-group-area--rWRIb";
export var buttonGroupDivider = "index-module--button-group-divider--LABc5";
export var mypageWrapper = "index-module--mypage-wrapper--RoSbA";
export var navigation = "index-module--navigation---ylHy";
export var root = "index-module--root--fKDzk";
export var rootHidden = "index-module--root-hidden--+-i1Y";
export var searchInputWrapper = "index-module--search-input-wrapper--5VX5F";
export var taglineArea = "index-module--tagline-area--1NiF-";
export var titleWrapper = "index-module--title-wrapper--3Heu+";